import { render, staticRenderFns } from "./DisplayPreferences.vue?vue&type=template&id=3707bc27&scoped=true"
import script from "./DisplayPreferences.vue?vue&type=script&lang=js"
export * from "./DisplayPreferences.vue?vue&type=script&lang=js"
import style0 from "./DisplayPreferences.vue?vue&type=style&index=0&id=3707bc27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707bc27",
  null
  
)

export default component.exports